import React, { useCallback, useState } from 'react'
import { useDropzone } from 'react-dropzone'

import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';

import { uploadFilesList, deleteFromList, addToList } from "../../service/upload/UploadFilesList"


interface UploadProps {
    header?: string
}

export default function UploadFilesDragAndDrop(props: UploadProps) {
    //let header: string = "Hochzuladende Dateien (Text, Bilder (JPG und PNG) oder PDF Dateien möglich)";
    let header: string = "File to upload (Text, Images (JPG and PNG) or PDF Files valid)";
    if(props.header !==  undefined) {
        header = props.header
    }

    let elementcounter: number = 0;

    //const [uploadFilesList, setUploadFilesList] = useState<Array<UploadFile>>(new Array<UploadFile>() );
    const [invalidate, setInvalidate] = useState<boolean>(false);

    // ---
    function handleClickDel (elName: string) {
        deleteFromList(elName);
        setInvalidate(!invalidate);
    }
    
    function UploadedFilesComponent() {
        let listFiles = new Array<JSX.Element>();

        uploadFilesList.forEach(element => {
            listFiles.push(
                <li>
                    {element.name} [ {element.size} bytes, {element.type} ]
                    <IconButton aria-label="delete" key={elementcounter++} onClick={(e) => { handleClickDel(element.name) }}>
                        <DeleteIcon />
                    </IconButton>
                    <br/>
                </li>
                );
        });

        return(
            <div style={{ overflow: "auto", height:"100px" }}>
                {listFiles}
            </div>
        );
    }

    // ---
    const onDrop = useCallback(acceptedFiles => {
        acceptedFiles.forEach((file: File) => {

            // Test if Mime-type is allowed (only JPG, PNG and PDF can be embedded):
            let filetype: string = file.type.toLowerCase();
            if(!filetype.includes("jpg") && !filetype.includes("jpeg") && !filetype.includes("png") && !filetype.includes("pdf")  && !filetype.includes("text")) {
                let msg: string = "Cannot embed file <" + file.name + "> with Mime-Type <" + file.type + "> for scurity reasons. Only Text, JPG, PNG and PDF allowed ! Please convert your file in one of these formats !";
                alert(msg);
                console.log(msg);
                //console.log("Cannot embed file <" + uploadFilesList[idx].name + "> with Mime-Type <" + uploadFilesList[idx].type + "> for scurity reasons. Only JPG, PNG and PDF allowed !");
                return;
            }
    
            // 
            const reader = new FileReader();
  
            reader.onabort = () => console.log('file reading was aborted');
            reader.onerror = () => console.log('file reading has failed');
            reader.onload = () => {
                // Do whatever you want with the file contents
                const binaryStr = reader.result;
                console.log("Uploadfile read: " + file.name);  // upload

                addToList(file.name, file.size, file.type, binaryStr);
                setInvalidate(!invalidate);
            }

            // 
            reader.readAsArrayBuffer(file);
        } 
    ) }, [ invalidate ])
    const { getRootProps, getInputProps, isDragActive } = useDropzone({onDrop})

    return (
        <Grid container style={{marginTop: "10px"}}>
            <Grid item xs={12}>
                <h4>{header}</h4>
            </Grid>
            <Grid item xs={5}>
                <div {...getRootProps()} style={{ border: "1px solid #F29401", marginTop: "10px"}}>
                    <input {...getInputProps()} />
                    {
                        isDragActive ? <p>Drop file here ...<br/>&nbsp;</p> : <p>To upload a file drag-and-drop it here, or click for selection dialog.</p>
                    }
                </div>
            </Grid>
            <Grid item xs={7}>
                <UploadedFilesComponent/>
            </Grid>
        </Grid>
    )
}
